import React from "react";
import Select from "react-select";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";

function ProductVariantInformation({
    formData,
    handleChange,
    // variantForm,
    colors = [],
    sizes = [],
    // handleVariantChange,
    handleSelectChange,
    config,
    editVariant,
    deleteVariant,
    addVariant,
    errors = {}
}) {
    const colorOptions = colors.map((item) => ({
        value: item.id,
        label: item.color_name
    }));
    const sizeOptions = sizes.map((item) => ({
        value: item.id,
        label: item.size_name
    }));
    const variantConfig = config?.variant_fields || { required: [], optional: [] };
    const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

    const showField = (fieldName) => allVariantFields.includes(fieldName);

    const isRequired = (fieldName) => variantConfig.required?.includes(fieldName) || false;

    // const getFieldLabel = (fieldName) => {
    //     const labels = {
    //         sku: 'SKU',
    //         color_ids: 'Colors',
    //         size_ids: 'Sizes',
    //         barcode: 'Barcode',
    //         model: 'Model',
    //         ram: 'RAM',
    //         storage: 'Storage',
    //         imei: 'IMEI',
    //         // warranty: 'Warranty',
    //         material: 'Material',
    //         dimensions: 'Dimensions',
    //         weight: 'Weight',
    //         stock: 'Stock',
    //         price: 'Price'
    //     };
    //     return labels[fieldName] || fieldName.replace('_', ' ').toUpperCase();
    // };
  
     const getFieldLabel = (fieldName) => {
        const fieldConfig = FIELD_REGISTRY[fieldName];
        // Agar registry mein label hai toh wo use karo, warna capitalise kar do
        return fieldConfig?.label || fieldName.replace('_', ' ').toUpperCase();
    };
  
    // const getFieldValue = (variant, fieldName) => {
    //     const value = variant[fieldName];
    //     if (Array.isArray(value)) {
    //         if (fieldName === 'color_ids') {
    //             return colors
    //                 .filter(c => value.includes(c.id))
    //                 .map(c => c.color_name)
    //                 .join(', ');
    //         }
    //         if (fieldName === 'size_ids') {
    //             return sizes
    //                 .filter(s => value.includes(s.id))
    //                 .map(s => s.size_name || s.name)
    //                 .join(', ');
    //         }
    //         return value.join(', ');
    //     }
    //     return value || '-';
    // };





        const getFieldValue = (variant, fieldName) => {
        const value = variant[fieldName];
        if (Array.isArray(value)) {
            if (fieldName === 'color_ids') {
                return colors.filter(c => value.includes(c.id)).map(c => c.color_name).join(', ');
            }
            if (fieldName === 'size_ids') {
                return sizes.filter(s => value.includes(s.id)).map(s => s.size_name || s.name).join(', ');
            }
            return value.join(', ');
        }
        return value || '-';
    };
    // const removeVariant = (index) => {
    //     const newVariants = formData.variants.filter((_, i) => i !== index);
    //     handleChange({
    //         target: {
    //             name: 'variants',
    //             value: newVariants
    //         }
    //     });
    // };
    return (
        <div className="card shadow-sm mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                    <i className="fa fa-cubes me-2"></i>
                    Product Variants
                </h5>
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                   onClick={() => addVariant()}
                >
                    <i className="fa fa-plus me-1"></i> Add Variant
                </button>
            </div>

            <div className="card-body">
                {!formData.variants || formData.variants.length === 0 ? (
                    <div className="text-center text-muted py-4">
                        <i className="fa fa-cubes fa-3x mb-3 d-block"></i>
                        <p>No variants added yet.</p>
                        <small>Click "Add Variant" to add product variants.</small>
                    </div>
                ) : (
                    formData?.variants.map((variant, index) => (
                        <div key={index} className="variant-item border rounded p-3 mb-3 position-relative">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <h6 className="text-primary mb-0">
                                    <i className="fa fa-cube me-2"></i>
                                    Variant {index + 1}
                                    {variant?.sku && (
                                        <span className="badge bg-secondary ms-2">{variant?.sku}</span>
                                    )}
                                </h6>
                             {formData.variants.length > 1 && (
        <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={() => deleteVariant(index)}
        >
            <i className="fa fa-trash me-1"></i>
            Remove
        </button>
    )}
                            </div>

                            <div className="row">
                                {/* SKU */}
                                {showField('sku') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('sku')} {isRequired('sku') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors[`variants.${index}.sku`] ? 'is-invalid' : ''}`}
                                            name={`variants.${index}.sku`}
                                            value={variant.sku || ""}
                                            onChange={handleChange}
                                            placeholder="Enter SKU"
                                        />
                                    </div>
                                )}

                                {/* Color */}
                                {showField('color_ids') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('color_ids')} {isRequired('color_ids') && <span className="text-danger">*</span>}
                                        </label>
                                        <Select
                                            isMulti
                                            options={colorOptions}
                                            value={colorOptions.filter(option =>
                                                (variant.color_ids || []).includes(option.value)
                                            )}
                                            onChange={(selected) =>
                                                handleSelectChange(index, "color_ids", selected)
                                            }
                                            placeholder="Select Colors..."
                                        />
                                    </div>
                                )}

                                {/* Size */}
                                {showField('size_ids') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('size_ids')} {isRequired('size_ids') && <span className="text-danger">*</span>}
                                        </label>
                                        <Select
                                            isMulti
                                            options={sizeOptions}
                                            value={sizeOptions.filter(option =>
                                                (variant.size_ids || []).includes(option.value)
                                            )}
                                            onChange={(selected) =>
                                                handleSelectChange(index, "size_ids", selected)
                                            }
                                            placeholder="Select Sizes..."
                                        />
                                    </div>
                                )}

                                {/* Barcode */}
                                {showField('barcode') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('barcode')} {isRequired('barcode') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.barcode`}
                                            value={variant.barcode || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Barcode"
                                        />
                                    </div>
                                )}

                                {/* Model */}
                                {showField('model') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('model')} {isRequired('model') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.model`}
                                            value={variant.model || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Model"
                                        />
                                    </div>
                                )}

                                {/* RAM */}
                                {showField('ram') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('ram')} {isRequired('ram') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors[`variants.${index}.ram`] ? 'is-invalid' : ''}`}
                                            name={`variants.${index}.ram`}
                                            value={variant.ram || ""}
                                            onChange={handleChange}
                                            placeholder="Enter RAM"
                                        />
                                    </div>
                                )}

                                {/* Storage */}
                                {showField('storage') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('storage')} {isRequired('storage') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors[`variants.${index}.storage`] ? 'is-invalid' : ''}`}
                                            name={`variants.${index}.storage`}
                                            value={variant.storage || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Storage"
                                        />
                                    </div>
                                )}

                                {/* IMEI */}
                                {showField('imei') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('imei')} {isRequired('imei') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.imei`}
                                            value={variant.imei || ""}
                                            onChange={handleChange}
                                            placeholder="Enter IMEI"
                                        />
                                    </div>
                                )}

                                {/* Warranty */}
                                {/* {showField('warranty') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('warranty')} {isRequired('warranty') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.warranty`}
                                            value={variant.warranty || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Warranty"
                                        />
                                    </div>
                                )} */}

                                {/* Material */}
                                {showField('material') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('material')} {isRequired('material') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.material`}
                                            value={variant.material || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Material"
                                        />
                                    </div>
                                )}

                                {/* Dimensions */}
                                {showField('dimensions') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('dimensions')} {isRequired('dimensions') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.dimensions`}
                                            value={variant.dimensions || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Dimensions"
                                        />
                                    </div>
                                )}

                                {/* Weight */}
                                {showField('weight') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('weight')} {isRequired('weight') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={`variants.${index}.weight`}
                                            value={variant.weight || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Weight"
                                        />
                                    </div>
                                )}

                                {/* Stock */}
                                {showField('stock') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('stock')} {isRequired('stock') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control ${errors[`variants.${index}.stock`] ? 'is-invalid' : ''}`}
                                            name={`variants.${index}.stock`}
                                            value={variant.stock || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Stock"
                                            min="0"
                                        />
                                    </div>
                                )}

                                {/* Price */}
                                {showField('price') && (
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label fw-bold">
                                            {getFieldLabel('price')} {isRequired('price') && <span className="text-danger">*</span>}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name={`variants.${index}.price`}
                                            value={variant.price || ""}
                                            onChange={handleChange}
                                            placeholder="Enter Price"
                                            step="0.01"
                                        />
                                    </div>
                                )}
                                {/* {showField("image") && (
    <div className="col-md-3 mb-3">
        <label className="form-label fw-bold">
            Variant Image
        </label>

        <input
            type="file"
            className="form-control"
            name={`variants.${index}.image`}
            accept="image/*"
            onChange={handleChange}
        />

        {variant.image && (
            <img
                src={URL.createObjectURL(variant.image)}
                alt=""
                width={80}
                className="mt-2 rounded border"
            />
        )}
    </div>
)} */}
                            </div>
                        </div>
                    ))
                )}
                {/* <div className="variant-list mt-4">
                <h6 className="mb-3">
                    <i className="fa fa-list me-2"></i>
                    Variant List ({formData.variants.length})
                </h6>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                {allVariantFields.map((field) => (
                                    <th key={field}>{getFieldLabel(field)}</th>
                                ))}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData.variants.map((variant, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    {allVariantFields.map((field) => (
                                        <td key={field}>{getFieldValue(variant, field)}</td>
                                    ))}
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-warning me-1"
                                            onClick={() => editVariant(index)}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => deleteVariant(index)}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                </div> */}
            </div>
        </div>
    );
}

export default ProductVariantInformation;